import { useEffect } from 'react';
import { useLocation } from 'wouter';

export function ReferralTracker() {
  const [location] = useLocation();

  useEffect(() => {
    // Check if there's a ref parameter in the URL
    const searchParams = new URLSearchParams(window.location.search);
    const refCode = searchParams.get('ref');
    
    if (refCode) {
      // Track the referral by calling the backend to set the cookie
      fetch(`/api/track-referral/${refCode}`)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            console.log('Referral tracked:', data.code);
            // Remove ref parameter from URL without reloading
            const url = new URL(window.location.href);
            url.searchParams.delete('ref');
            window.history.replaceState({}, '', url.pathname);
          }
        })
        .catch(error => {
          console.error('Failed to track referral:', error);
        });
    }
  }, [location]);

  return null; // This component doesn't render anything
}
